/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState, useRef } from "react";
import useStyles from "./styles";
import InputSearchProduct from "./Components/InputSearchProduct";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ProductItem from "components/ProductItem";
import ConfirmOrder from "components/ConfirmOrder";
import NonProduct from "./Components/NonProduct";
import MenuProduct from "./Components/MenuProduct";
import InfiniteScroll from "react-infinite-scroll-component";
import CircularProgress from "@material-ui/core/CircularProgress";
import theme from "theme";

import {
	getListProductAction,
	setCartAction,
	getMenuProductBrandsAction
} from "store/actions/OrderPageAction";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { setValueSearchProductAction } from "store/actions/GlobalAction";

let changeListProduct = [];
const NUMBER_PRODUCT_MORE = 18;
const HEIGHT_TITLE_WRAPPER = 39;

const FindProductPage = props => {
	const classes = useStyles();
	const history = useHistory();
	const {
		valueSearch,
		listProduct,
		carts,
		menuProductBrands,
		infoShop,
		totalListProduct,
		dispatchSetCart,
		dispatchSetValueSearchProduct,
		dispatchGetListProduct,
		dispatchGetMenuProductBrands
	} = props;

	const business = infoShop?.business;
	const refProductList = useRef(null);
	const divToScrollTo = document.getElementById("refProductList");
	const distanceProductToTop = divToScrollTo?.offsetTop;

	const [allProduct, setAllProduct] = useState([]);
	const [products, setProducts] = useState([]);
	const [typeActive, setTypeActive] = useState("");
	const [title, setTitle] = useState("Tất cả sản phẩm");
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(1);

	useEffect(() => {
		if (!carts) {
			return;
		}
		changeListProduct = carts;
	}, [carts]);

	const getUniqueProductIds = products => {
		const uniqueProductIds = new Set();
		const uniqueProducts = [];
		for (const product of products) {
			if (!uniqueProductIds.has(product.id)) {
				uniqueProducts.push(product);
				uniqueProductIds.add(product.id);
			}
		}
		return uniqueProducts;
	};

	const configDataProduct = data => {
		return data.map(item => {
			let index = carts.findIndex(order => order.id === item.id);
			if (index > -1) {
				return { ...item, isSelected: true };
			} else {
				return { ...item, isSelected: false };
			}
		});
	};

	useEffect(() => {
		if (!!listProduct) {
			const productsFilter = !!typeActive
				? listProduct?.filter(
						product => product?.productBrandCode === typeActive
				  )
				: listProduct;
			const tempProducts = [...products, ...productsFilter];
			const tempAllProduct = [...allProduct, ...listProduct];
			const productsSelected = configDataProduct(
				getUniqueProductIds(tempProducts)
			);
			const allProductsSelected = configDataProduct(
				getUniqueProductIds(tempAllProduct)
			);
			setProducts(productsSelected);
			setAllProduct(getUniqueProductIds(allProductsSelected));
		}
	}, [listProduct]);

	const segmentCodes = menuProductBrands?.menu1?.concat(
		menuProductBrands?.menu2
	);

	useEffect(() => {
		if (valueSearch) {
			return;
		}
		setProducts([]);
		const data = {
			keyword: valueSearch,
			requirePrice: true,
			business: business,
			count: NUMBER_PRODUCT_MORE,
			offset: 0
		};
		dispatchGetListProduct(data);
		dispatchGetMenuProductBrands({ business: business });
	}, []);

	const handleSearchProduct = e => {
		dispatchSetValueSearchProduct(e);
		setPage(1);
		setProducts([]);
		setAllProduct([]);
		const data = {
			keyword: e,
			requirePrice: true,
			business: business,
			count: NUMBER_PRODUCT_MORE,
			offset: 0,
			productBrandCodes: typeActive
		};
		dispatchGetListProduct(data);
		history.push("/find_product");
	};

	const updateChangeListProduct = useCallback(item => {
		if (changeListProduct?.find(product => product.id === item.id)) {
			const dataFilter = changeListProduct.filter(
				el => el.id !== item.id
			);
			changeListProduct = dataFilter;
		} else {
			changeListProduct = [...changeListProduct, item];
		}
		dispatchSetCart(changeListProduct);
	}, []);

	const getChangeListProduct = () => {
		return changeListProduct;
	};

	const getTitleInListProduct = type => {
		const segment = segmentCodes?.find(sg => sg?.code === type);
		if (!segment) {
			setTitle("Tất cả sản phẩm");
			return;
		}
		setTitle(segment?.name || "");
	};

	const handleSelectMenu = type => {
		getTitleInListProduct(type);
		setPage(1);
		setProducts([]);
		setAllProduct([]);
		setHasMore(true);

		const data = {
			keyword: valueSearch,
			requirePrice: true,
			business: business,
			count: NUMBER_PRODUCT_MORE,
			offset: 0,
			productBrandCodes: type
		};
		dispatchGetListProduct(data);
	};

	const fetchMoreData = () => {
		if (products.length >= totalListProduct) {
			setHasMore(false);
			return;
		}
		setTimeout(() => {
			setPage(prevPage => prevPage + 1);
			const data = {
				keyword: valueSearch,
				requirePrice: true,
				business: business,
				count: NUMBER_PRODUCT_MORE,
				offset: page * NUMBER_PRODUCT_MORE,
				productBrandCodes: typeActive
			};
			dispatchGetListProduct(data);
		}, 1000);
	};

	return (
		<Grid>
			<Grid classes={{ root: classes.header }}>
				<Grid
					classes={{ root: classes.btnBack }}
					onClick={() => {
						dispatchSetValueSearchProduct("");
						history.push("/home");
					}}
				>
					<ArrowBackIcon />
				</Grid>
				<InputSearchProduct
					handleSearchProduct={handleSearchProduct}
					valueSearch={valueSearch}
				/>
			</Grid>
			<MenuProduct
				menus={menuProductBrands}
				setTypeActive={setTypeActive}
				typeActive={typeActive}
				handleSelectMenu={handleSelectMenu}
			/>
			<Grid
				classes={{ root: classes.rootBody }}
				style={{
					height: `calc(100vh - ${distanceProductToTop}px)`,
					background:
						products?.length > 0 ? "" : theme.palette.common.white
				}}
			>
				<div ref={refProductList} id="refProductList" />
				{products?.length > 0 ? (
					<React.Fragment>
						<Grid
							classes={{ root: classes.title }}
							style={{
								padding: "10px 16px 8px"
							}}
						>
							{title}
						</Grid>
						<Grid
							style={{
								height: `calc(100vh - ${
									distanceProductToTop + HEIGHT_TITLE_WRAPPER
								}px)`
							}}
						>
							<InfiniteScroll
								dataLength={allProduct.length}
								next={fetchMoreData}
								hasMore={hasMore}
								height={`calc(100vh - ${
									distanceProductToTop + HEIGHT_TITLE_WRAPPER
								}px)`}
								scrollThreshold={0.5}
								style={{ padding: "0px 16px" }}
								loader={
									<Grid
										style={{
											display: "flex",
											justifyContent: "center",
											marginBottom: 5
										}}
									>
										<CircularProgress
											thickness={4}
											style={{ height: 25, width: 25 }}
										/>
									</Grid>
								}
							>
								{products.map((product, index) => (
									<ProductItem
										product={product}
										key={index}
										updateChangeListProduct={
											updateChangeListProduct
										}
										products={products}
										carts={carts}
									/>
								))}
								{carts.length > 0 && !hasMore && (
									<div style={{ height: 70 }} />
								)}
							</InfiniteScroll>
						</Grid>
					</React.Fragment>
				) : (
					<NonProduct
						height={`calc(100vh - ${
							distanceProductToTop + HEIGHT_TITLE_WRAPPER
						}px)`}
					/>
				)}
				{carts?.length > 0 && (
					<ConfirmOrder
						bottom={0}
						handleConfirmOrder={() => {
							history.push("/carts");
						}}
						listProduct={carts}
						getChangeListProduct={getChangeListProduct}
					/>
				)}
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		valueSearch: state.globalReducer.valueSearch,
		listProduct: state.orderPageReducer.listProduct,
		carts: state.orderPageReducer.carts,
		menuProductBrands: state.orderPageReducer.menuProductBrands,
		infoShop: state.homePageReducer.infoShop,
		totalListProduct: state.orderPageReducer.totalListProduct
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatchSetValueSearchProduct: value => {
			dispatch(setValueSearchProductAction(value));
		},
		dispatchGetListProduct: value => {
			dispatch(getListProductAction(value));
		},
		dispatchSetCart: params => {
			dispatch(setCartAction(params));
		},
		dispatchGetMenuProductBrands: params => {
			dispatch(getMenuProductBrandsAction(params));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FindProductPage);
